/** `/c/$companyId/banking` — the bank, wallet and cash accounts. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { BankingScreen } from "../banking/accounts/BankingScreen";
import { CODE_SETS } from "../ledger/books";
import { CodeGate } from "../shell/CodeGate";

export const Route = createFileRoute("/_auth/c/$companyId/banking/")({
  component: BankingRoute,
});

function BankingRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.BANK}>
      <BankingScreen companyId={companyId} />
    </CodeGate>
  );
}
